export default __webpack_public_path__ + "static/media/logo.c2b400ad.svg";